// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SOQm","content":"styles_content__2ZCwu"};